import flagsmith from 'flagsmith';

/**
 * DO NOT EDIT THIS
 * - contact @martin.slaby when you need to adjust this set
 *
 * preconditions for removing:
 * - At any point in the codebase, you shouldn't be working with DG rowData,
 *   including rowData param in actionCallback, any of the overrides, etc.
 */
const ALLOWED_GRID_CODES = new Set([
  'vehicles-in-advertisement',
  'vehicle',
  'vehicle-opensearch',
  'sale-vehicle-os',
  'business-case-add-vehicle',
  'car-audit-vehicle-full-list',
  'interest-vehicle-list',
  'rental-vehicle-os',
  'report-service-order-statistic',
  'report-service-item-statistic',
  'service-vehicle-os',
  'service-order',
  'report-warehouse-direct-sales-item',
  'customer',
  'service-history-service-order',
  'business-case',
  'business-case-opensearch',
  'car-audit-vehicle-list',
  'service-case-opensearch',
  'service-case-order-job-items',
  'tire-list',
  'customer-tire-list',
  'tire-order-wheel-service-case-creating',
  'vehicle-tire-list',
  'invoicing',
  'customer-invoicing',
  'customer-vehicles-ownership',
  'report-service-item-mechanic',
  'customer-service-order',
  'report-warehouse-direct-sales',
  'documents-pre-accounting',
  'warehouse-articles',
  'tire-order-wheel-service-case',
  'vehicle-history-service-order',
  'interest',
  'customer-service-case',
  'tire-order-set',
  'service-case',
  'service-history-service-case',
  'vehicle-history-service-case',
  'cash-receipts',
  'warehouse-purchase-list',
  'warehouse-supplier-order-purchase-list-cart',
  'service-history-order-items',
  'vehicle-history-order-items',
  'report-warehouse-value',
  'customer-business-case-history',
  'vehicle_in_warehouse_history',
  'tire-order-set-archived',
  'warehouse-article-catalogs-info',
  'postpone-job',
  'customer-interests-list',
  'customer-vehicles-list',
  'complaint',
  'issue-note-service-order-items',
  'warehouse-availability',
  'warehouse-credit-note-item-add',
  'service-items-external-history',
  'vehicle-history-service-items-external-history',
  'warehouse-parts-request',
  'vehicle-business-case-history',
  'sale_vehicle_price_snapshot_dg',
  'issue-note-service-order-warehouse-articles',
  'warehouse-delivery-note-items',
  'tire-order',
]);
/**
 * DO NOT EDIT THIS
 * - contact @martin.slaby when you need to adjust this set
 *
 * preconditions for removing:
 * - At any point in the codebase, you shouldn't be working with DG rowData,
 *   including rowData param in actionCallback, any of the overrides, etc.
 */

export const isPartialColumnFetchingEnabled = (gridCode: string) => {
  const isGridWhiteListed = ALLOWED_GRID_CODES.has(gridCode);
  const hasFeatureFlag = flagsmith.hasFeature('core_partial_column_fetching');

  return isGridWhiteListed && hasFeatureFlag;
};
